const API_URL = process.env.REACT_APP_API_URL;
const USER_URL = `${API_URL}/api/user`;

export const fetchUser = async () => {
    try {
        const response = await fetch(`${USER_URL}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch user');
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch user');
    }
};

export const fetchUserCredits = async () => {
    try {
        const response = await fetch(`${USER_URL}/credits`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch user credits');
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch user credits');
    }
};
